import { get, post } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { withdraws as types } from 'types';

const withdraws = {
    get() {
        return get<types.TWithdraws[]>(
            `${endpoints[EEndpoints.withdrawsGet]()}`,
        );
    },
    add(reqBody: types.TAddWithdraw) {
        return post<types.TAddWithdraw, null>(
            `${endpoints[EEndpoints.withdrawsAdd]()}`,
            {
                ...reqBody,
            },
        );
    },
};

export default withdraws;
